import React from "react";
import { useTranslation } from "react-i18next";

import { close_svg } from "../Placeholder/placeholder-elements";

export function withModal(
  Component: React.FC | React.ComponentClass,
  props: object,
  control: { has_modal: boolean; toggleModal: () => void },
  children: React.ReactNode | undefined,
): React.ComponentClass {
  const { t } = useTranslation("global");

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("o-modal")) {
      control.toggleModal();
    }
  };

  return class ModalWrapper extends React.Component {
    render() {
      return (
        <div
          className={`o-modal ${control.has_modal ? "o-modal--show" : "o-modal--hidden"}`}
          onClick={handleOverlayClick}
        >
          <div className={"c-modal"}>
            <div className={"m-modal__header"}>
              <div className="title">{children}</div>
              <button
                className={"button-clean"}
                onClick={control.toggleModal}
                aria-label={t("cerrar ventana emergente")}
              >
                {close_svg}{" "}
              </button>
            </div>
            <div className={"m-modal__component"}>
              <Component {...props} />
            </div>
          </div>
        </div>
      );
    }
  };
}
